import AdminLayout from "components/layouts/AdminLayout"
import NewLoan from "components/newLoan/NewLoan";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router";
import { TranslateString } from "Utils/Common";

const NewLoanPage = (props: any) => {
    const navigate = useNavigate();

  return (
    <AdminLayout>
        <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left cu-tab-text">
            <h4 className="cu-m-0 cu-p-0">
                <button className="ant-btn cu-border-0 back-btn text-primary" onClick={() => navigate(-1)}><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                &nbsp;
                <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{TranslateString('create_new_loan')}</button>
            </h4>
        </div>
        <NewLoan props={props} />
    </AdminLayout>
  )
}

export default NewLoanPage